module.exports = __webpack_public_path__ + "static/media/icon-service-modulesB2.fec44bd3.png";